// SCADENZE_PERSONE_v1 — scadenzario diviso per persona (ditta, Marco, Edoardo, vecchi soci)
import React, { useState, useEffect } from "react";

const C = {
  bg: "#0f1117", surface: "#1a1d27", surface2: "#21253a", border: "#2a2e45", accent: "#f5a623", accentSoft: "#f5a62322",
  text: "#e8eaf2", muted: "#7b82a0", dim: "#4a5068", ok: "#3ecf8e", err: "#f06060", info: "#4e9af5",
};
const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
const PERSONE_BASE = [
  { id: "ditta", nome: "Ditta (vecchia SNC)", tipo: "ditta", banca: [] },
  { id: "marco", nome: "Marco", tipo: "socio", banca: ["Bertocci Marco"] },
  { id: "edoardo", nome: "Edoardo", tipo: "socio", banca: ["Bertocci Edoardo"] },
  { id: "ion", nome: "Ion", tipo: "socio", banca: [] },
  { id: "ilie", nome: "Ilie", tipo: "socio", banca: [] },
  { id: "mazzei", nome: "Mazzei", tipo: "socio", banca: [] },
];
const CAT_SOCI = ["Compenso titolare", "Soci: prelievo o restituzione (non è un costo)"];

function tok() { try { return localStorage.getItem("bertoc_jwt") || ""; } catch (e) { return ""; } }
async function api(url, opts) {
  const o = opts || {};
  const h = { Authorization: "Bearer " + tok() };
  if (o.body) h["Content-Type"] = "application/json";
  const r = await fetch(url, { method: o.method || "GET", headers: h, body: o.body ? JSON.stringify(o.body) : undefined });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || ("Errore " + r.status));
  return j;
}
export async function caricaPersone() {
  const j = await api("/api/scadenze-persone");
  return { persone: j.persone && j.persone.length ? j.persone : PERSONE_BASE, alias: j.alias || {} };
}
// persona di una scadenza: prima la scelta salvata, poi il nome
export function personaDi(s, cfg) {
  const k = String((s && s.intestatario) || "").trim();
  const alias = (cfg && cfg.alias) || {};
  if (alias[k]) return alias[k];
  const t = k.toLowerCase();
  if (!t) return "";
  if (/bertoc/.test(t) && /(project|irap|snc|srl)/.test(t)) return "ditta";
  if (/marco/.test(t)) return "marco";
  if (/edoardo/.test(t)) return "edoardo";
  if (/\bion\b|birdeanu/.test(t)) return "ion";
  if (/ilie|cernaianu/.test(t)) return "ilie";
  if (/mazze/.test(t)) return "mazzei";
  return "";
}
const eu = v => "€ " + Math.round(Number(v) || 0).toLocaleString("it-IT");
const parseD = s => { const t = String(s || ""); let m = t.match(/^(\d{4})-(\d{2})-(\d{2})/); if (m) return m[1] + "-" + m[2] + "-" + m[3]; m = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/); return m ? m[3] + "-" + m[2].padStart(2, "0") + "-" + m[1].padStart(2, "0") : ""; };
const inp = { padding: "7px 9px", borderRadius: 8, border: "1px solid " + C.border, background: C.bg, color: C.text, fontSize: 13, fontFamily: "inherit", outline: "none" };
const btn = primo => ({ padding: "7px 12px", borderRadius: 8, border: "1px solid " + (primo ? C.accent : C.border), background: primo ? C.accent : C.surface, color: primo ? "#1a1d27" : C.text, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" });

export default function ScadenzePersone({ scadenzeDB = [], cfg, setCfg, personaSel, setPersonaSel }) {
  const [aperto, setAperto] = useState(false);
  const [vediMesi, setVediMesi] = useState(false);
  const [banca, setBanca] = useState([]);
  useEffect(() => { api("/api/banca/movimenti").then(j => setBanca(j.movimenti || [])).catch(() => {}); }, []);
  const persone = (cfg && cfg.persone) || PERSONE_BASE;
  const oggi = new Date().toISOString().slice(0, 10);
  const meseOggi = oggi.slice(0, 7);
  const mesi = Array.from({ length: 12 }, (_, i) => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() + i); return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0"); });
  const per = {};
  [...persone.map(p => p.id), ""].forEach(id => { per[id] = { scaduto: 0, mese: 0, aperto: 0, pagato: 0, n: 0, mesi: Array(12).fill(0) }; });
  scadenzeDB.forEach(s => {
    const id = personaDi(s, cfg); const o = per[id] || per[""];
    const v = parseFloat(s.importo) || 0; const d = parseD(s.scadenza);
    o.n++;
    if (s.pagata) { o.pagato += v; return; }
    o.aperto += v;
    if (d && d < oggi) o.scaduto += v;
    if (d && d.slice(0, 7) === meseOggi) o.mese += v;
    const i = mesi.indexOf((d || "").slice(0, 7)); if (i >= 0) o.mesi[i] += v;
  });
  // quanto la ditta ha girato a ciascun socio negli ultimi 12 mesi (bonifici con categoria compenso / soci)
  const unAnnoFa = new Date(); unAnnoFa.setFullYear(unAnnoFa.getFullYear() - 1);
  const daData = unAnnoFa.toISOString().slice(0, 10);
  const girato = {};
  banca.filter(m => m.importo < 0 && m.data >= daData && m.abb && CAT_SOCI.includes(m.abb.categoria)).forEach(m => {
    const p = persone.find(p => (p.banca || []).some(n => n && String(m.controparte || "").toLowerCase().includes(n.toLowerCase())));
    if (p) girato[p.id] = (girato[p.id] || 0) - m.importo;
  });
  const senza = per[""].n;

  return (
    <div style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: 14, color: C.text }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <span onClick={() => setPersonaSel("")} style={chip(personaSel === "")}>Tutti</span>
        {persone.map(p => (
          <span key={p.id} onClick={() => setPersonaSel(p.id)} style={chip(personaSel === p.id)}>
            {p.nome}{per[p.id] && per[p.id].aperto ? <span style={{ fontWeight: 400, opacity: 0.8 }}> · {eu(per[p.id].aperto)}</span> : null}
          </span>
        ))}
        {senza > 0 && <span onClick={() => setPersonaSel("_nessuna")} style={chip(personaSel === "_nessuna", C.err)}>Senza persona · {senza}</span>}
        <span style={{ flex: 1 }} />
        <button style={btn(false)} onClick={() => setVediMesi(!vediMesi)}>{vediMesi ? "▾" : "▸"} Prossimi 12 mesi</button>
        <button style={btn(false)} onClick={() => setAperto(true)}>👥 Persone e nomi</button>
      </div>
      {personaSel && personaSel !== "_nessuna" && per[personaSel] && (
        <div style={{ fontSize: 13, color: C.muted, marginTop: 10 }}>
          {(persone.find(p => p.id === personaSel) || {}).nome}: scaduto <b style={{ color: C.err }}>{eu(per[personaSel].scaduto)}</b> · questo mese <b style={{ color: C.accent }}>{eu(per[personaSel].mese)}</b> · da pagare <b style={{ color: C.text }}>{eu(per[personaSel].aperto)}</b> · pagato <b style={{ color: C.ok }}>{eu(per[personaSel].pagato)}</b>
          {girato[personaSel] ? <> · girati dalla ditta negli ultimi 12 mesi <b style={{ color: C.info }}>{eu(girato[personaSel])}</b></> : null}
        </div>
      )}
      {vediMesi && (
        <div style={{ overflowX: "auto", marginTop: 12 }}>
          <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12, minWidth: 820 }}>
            <thead><tr style={{ color: C.muted }}>
              <th style={{ textAlign: "left", padding: "6px 4px" }}>Da pagare</th>
              <th style={{ textAlign: "right", padding: "6px 4px", color: C.err }}>Scaduto</th>
              {mesi.map(m => <th key={m} style={{ textAlign: "right", padding: "6px 4px" }}>{MESI[parseInt(m.slice(5, 7), 10) - 1]}{m.slice(5, 7) === "01" ? " " + m.slice(2, 4) : ""}</th>)}
            </tr></thead>
            <tbody>
              {persone.filter(p => per[p.id] && per[p.id].aperto).map(p => (
                <tr key={p.id} style={{ borderTop: "1px solid " + C.border }}>
                  <td style={{ padding: "6px 4px", fontWeight: 600 }}>{p.nome}</td>
                  <td style={{ padding: "6px 4px", textAlign: "right", color: per[p.id].scaduto ? C.err : C.dim }}>{per[p.id].scaduto ? eu(per[p.id].scaduto) : "·"}</td>
                  {per[p.id].mesi.map((v, i) => <td key={i} style={{ padding: "6px 4px", textAlign: "right", color: v ? C.text : C.dim }}>{v ? eu(v) : "·"}</td>)}
                </tr>
              ))}
              <tr style={{ borderTop: "2px solid " + C.border, fontWeight: 700 }}>
                <td style={{ padding: "6px 4px" }}>Totale</td>
                <td style={{ padding: "6px 4px", textAlign: "right", color: C.err }}>{eu(Object.values(per).reduce((t, o) => t + o.scaduto, 0))}</td>
                {mesi.map((m, i) => <td key={m} style={{ padding: "6px 4px", textAlign: "right" }}>{eu(Object.values(per).reduce((t, o) => t + o.mesi[i], 0))}</td>)}
              </tr>
            </tbody>
          </table>
          <div style={{ fontSize: 12, color: C.muted, marginTop: 6 }}>Quanto serve mese per mese a ciascuno per le rate. La ditta di oggi (la srl) non c'è: qui ci sono le rate della vecchia SNC e quelle personali.</div>
        </div>
      )}
      {aperto && <FinestraPersone scadenzeDB={scadenzeDB} cfg={{ persone, alias: (cfg && cfg.alias) || {} }} setCfg={setCfg} onClose={() => setAperto(false)} />}
    </div>
  );
}
function chip(on, col) {
  const c = col || C.accent;
  return { padding: "6px 12px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 700, border: "1px solid " + (on ? c : C.border), background: on ? c + "22" : C.bg, color: on ? c : C.muted, userSelect: "none", whiteSpace: "nowrap" };
}

function FinestraPersone({ scadenzeDB, cfg, setCfg, onClose }) {
  const [persone, setPersone] = useState(cfg.persone.map(p => ({ ...p, banca: (p.banca || []).join(", ") })));
  const [alias, setAlias] = useState({ ...cfg.alias });
  const [nomiNuovi, setNomiNuovi] = useState({});
  const [lavoro, setLavoro] = useState(false);
  const [msg, setMsg] = useState("");
  const scritture = {};
  scadenzeDB.forEach(s => { const k = String(s.intestatario || "").trim(); const o = scritture[k] = scritture[k] || { n: 0, aperte: 0 }; o.n++; if (!s.pagata) o.aperte++; });
  const elenco = Object.keys(scritture).sort((a, b) => a.localeCompare(b));
  const cfgOra = () => ({ persone: persone.map(p => ({ ...p, banca: String(p.banca || "").split(",").map(x => x.trim()).filter(Boolean) })), alias });
  const scelta = k => alias[k] || personaDi({ intestatario: k }, { alias: {} });

  async function salva() {
    setLavoro(true);
    try {
      const c = cfgOra();
      const fisso = { ...c.alias };
      elenco.forEach(k => { if (k && !fisso[k]) { const p = personaDi({ intestatario: k }, { alias: {} }); if (p) fisso[k] = p; } });
      await api("/api/scadenze-persone", { method: "PUT", body: { persone: c.persone, alias: fisso } });
      setCfg({ persone: c.persone, alias: fisso });
      setMsg("✓ Salvato");
    } catch (e) { alert(e.message); }
    setLavoro(false);
  }
  async function rinomina(k) {
    const a = String(nomiNuovi[k] || "").trim();
    if (!a || a === k) return;
    if (!window.confirm("Rinominare \"" + (k || "(vuoto)") + "\" in \"" + a + "\" in tutte le " + scritture[k].n + " scadenze?\n\nPrima il gestionale fa una copia di sicurezza del database.")) return;
    setLavoro(true);
    try {
      const j = await api("/api/scadenze/rinomina-intestatario", { method: "POST", body: { da: k, a } });
      const p = scelta(k);
      const al = { ...alias }; delete al[k]; if (p) al[a] = p;
      setAlias(al);
      await api("/api/scadenze-persone", { method: "PUT", body: { ...cfgOra(), alias: al } });
      setCfg({ ...cfgOra(), alias: al });
      setMsg("✓ Rinominate " + j.n + " scadenze. La lista si aggiorna in pochi secondi.");
    } catch (e) { alert(e.message); }
    setLavoro(false);
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 1000, display: "flex", justifyContent: "center", alignItems: "flex-start", overflowY: "auto", padding: "24px 10px" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 14, padding: 18, width: "100%", maxWidth: 860, color: C.text }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 18 }}>👥 Persone e nomi</div>
          <button style={btn(false)} onClick={onClose}>✕</button>
        </div>
        {msg && <div style={{ color: C.ok, fontSize: 13, marginTop: 8 }}>{msg}</div>}

        <div style={{ fontWeight: 700, marginTop: 14, marginBottom: 6 }}>Persone</div>
        {persone.map((p, i) => (
          <div key={p.id} style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", padding: "4px 0" }}>
            <input style={{ ...inp, width: 190 }} value={p.nome} onChange={e => setPersone(ps => ps.map((x, j) => j === i ? { ...x, nome: e.target.value } : x))} />
            <select style={inp} value={p.tipo} onChange={e => setPersone(ps => ps.map((x, j) => j === i ? { ...x, tipo: e.target.value } : x))}>
              <option value="ditta">ditta</option><option value="socio">socio</option><option value="altro">altro</option>
            </select>
            <input style={{ ...inp, flex: 1, minWidth: 180 }} placeholder="nome nei bonifici (es. Bertocci Marco)" value={p.banca} onChange={e => setPersone(ps => ps.map((x, j) => j === i ? { ...x, banca: e.target.value } : x))} />
          </div>
        ))}
        <button style={{ ...btn(false), marginTop: 6 }} onClick={() => setPersone(ps => ps.concat([{ id: "p" + Date.now().toString(36), nome: "Nuova persona", tipo: "socio", banca: "" }]))}>+ Aggiungi persona</button>
        <div style={{ fontSize: 12, color: C.muted, marginTop: 6 }}>"Nome nei bonifici" serve a contare quanto la ditta ha girato a quella persona (movimenti della banca con categoria Compenso titolare o Soci).</div>

        <div style={{ fontWeight: 700, marginTop: 16, marginBottom: 6 }}>Come è scritto l'intestatario nelle scadenze</div>
        {elenco.map(k => (
          <div key={k || "_vuoto"} style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", padding: "6px 0", borderTop: "1px solid " + C.border, fontSize: 13 }}>
            <span style={{ width: 210, fontWeight: 600 }}>{k || <i style={{ color: C.err }}>(vuoto)</i>} <span style={{ color: C.muted, fontWeight: 400 }}>· {scritture[k].n} ({scritture[k].aperte} da pagare)</span></span>
            <select style={{ ...inp, width: 170 }} value={scelta(k)} onChange={e => setAlias({ ...alias, [k]: e.target.value })}>
              <option value="">— nessuna —</option>
              {persone.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
            </select>
            {k && <>
              <input style={{ ...inp, width: 150 }} placeholder="rinomina in…" value={nomiNuovi[k] || ""} onChange={e => setNomiNuovi({ ...nomiNuovi, [k]: e.target.value })} />
              <button style={btn(false)} disabled={lavoro || !String(nomiNuovi[k] || "").trim()} onClick={() => rinomina(k)}>Rinomina</button>
            </>}
          </div>
        ))}
        <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>Le scadenze senza intestatario si sistemano una per una con ✏️ nella lista. Se nel nome c'è il numero della pratica (Marco 1, Marco 4) conviene tenerlo.</div>
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button style={btn(true)} disabled={lavoro} onClick={salva}>Salva persone</button>
          <button style={btn(false)} onClick={onClose}>Chiudi</button>
        </div>
      </div>
    </div>
  );
}
